import { render, staticRenderFns } from "./AddArticleCategory.vue?vue&type=template&id=7ff2f3f0&scoped=true&"
import script from "./AddArticleCategory.vue?vue&type=script&lang=js&"
export * from "./AddArticleCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddArticleCategory.vue?vue&type=style&index=0&id=7ff2f3f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff2f3f0",
  null
  
)

export default component.exports